import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PageContainer from 'components/@layout/PageContainer';
import useAppAccess from 'hooks/use-app-access';
import { ModuleProps } from 'types';
import { ProductType } from 'types/schema-generated-types';
import HeaderBar from '../HeaderBar';
import AppCardContainer from './components/AppCardContainer';

export type Props = ModuleProps;

const AppAccess = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('AppAccess');
  const [{ apps }] = useAppAccess();

  const studentApps = apps.filter(({ pliManagedApp }) => pliManagedApp.type !== ProductType.USER);
  const educatorApps = apps.filter(({ pliManagedApp }) => pliManagedApp.type === ProductType.USER);

  return (
    <PageContainer loading={!apps}>
      <HeaderBar {...props} />
      <Box className={classes.mainContainer}>
        <Typography variant="h2" className={classes.title}>
          {t('userAppsTitle')}
        </Typography>
        <AppCardContainer apps={educatorApps} />
        <Typography variant="h2" className={classes.title}>
          {t('studentAppsTitle')}
        </Typography>
        <AppCardContainer apps={studentApps} />
      </Box>
    </PageContainer>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(1.5)
  },
  mainContainer: {
    padding: theme.spacing(4)
  }
}));

export default AppAccess;
